import React from 'react';

import BrowserRouter from 'react-router-dom/BrowserRouter';
import Route from 'react-router-dom/Route';
import Switch from 'react-router-dom/Switch';
import Redirect from 'react-router-dom/Redirect';
import withStyles from '@material-ui/core/styles/withStyles';
import AppBar from '@material-ui/core/AppBar';
import Drawer from '@material-ui/core/Drawer';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import MenuIcon from '@material-ui/icons/Menu';
import CssBaseline from '@material-ui/core/CssBaseline';
import Loadable from 'react-loadable';

import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import MoreIcon from '@material-ui/icons/MoreVert';
import SettingsIcon from '@material-ui/icons/Settings';
import ShareIcon from '@material-ui/icons/Share';

import * as Sentry from '@sentry/browser';

import Loading from './Loading';
import SnackbarMessage from './SnackbarMessage';
import './App.css';

import * as Edt from './libs/EdtHandler';
import ViewModel from './ViewModel';

const styles = theme => ({
  app: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  flex: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  list: {
    width: 250,
  },
  drawerMenuContainer: {
    height: '100%',
  },
  whiteIcon: {
    color: '#fff',
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
});

const LoadableAccueil = Loadable({
  loader: () => import('./Accueil/Accueil'),
  loading: Loading,
});

const LoadableEdt = Loadable({
  loader: () => import('./Edt/Edt'),
  loading: Loading
});

const LoadableEdtAdd = Loadable({
  loader: () => import('./Edt/EdtAdd'),
  loading: Loading
});

const LoadableHelp = Loadable({
  loader: () => import('./Help/Help'),
  loading: Loading
});

const LoadableMenuDrawer = Loadable({
  loader: () => import('./DrawerMenu'),
  loading: Loading,
});

const LoadableWelcomeSlider = Loadable({
  loader: () => import('./WelcomeSlider/WelcomeSlider'),
  loading: Loading,
});

const LoadableNoMatch = Loadable({
  loader: () => import('./NoMatch/NoMatch'),
  loading: Loading,
});

const LoadableHomeRedirect = Loadable({
  loader: () => import('./HomeRedirect/HomeRedirect'),
  loading: Loading,
});

const LoadableFaq = Loadable({
  loader: () => import('./Faq/Faq'),
  loading: Loading,
});

const LoadableContact = Loadable({
  loader: () => import('./Contact/Contact'),
  loading: Loading,
});

const LoadableMentions = Loadable({
  loader: () => import('./Mentions/Mentions'),
  loading: Loading,
});

const LoadableCookies = Loadable({
  loader: () => import('./Cookies/Cookies'),
  loading: Loading,
});

class App extends React.Component {
  state = {
    drawerOpened: false,
    edts: Edt.edts,
    appBarTitle: ViewModel.defaultTitle,
    edt: null,
    mobileMoreAnchorEl: null,
    snackbarMessageOpen: false,
    snackbarMessageResponse: null,
    snackbarMessageType: null,
  }

  toggleDrawer = () => {
    this.setState(state => ({ drawerOpened: !state.drawerOpened }));
  };

  getAllEdtsFromLocal = () => {
    this.setState({
      edts: Edt.getAllEdts()
    })
  }

  updateAppViewModel = () => {
    this.setState({
      appBarTitle: ViewModel.model.appBarTitle,
      edt: ViewModel.model.edt,
      isLoading: ViewModel.model.isLoading,
    })
  }

  handleFavorite = () => {
    let oldEdt = this.state.edt;
    oldEdt.favorite = !oldEdt.favorite;

    Edt.updateFavoriteEdt(oldEdt);

    this.setState({
      edt: ViewModel.model.edt,
    })
  }

  handleSettings = () => {
    window.location.hash = "settings";
  }

  handleShare = () => {
    window.location.hash = "share";
  }

  componentDidMount = () => {
    this.getAllEdtsFromLocal();
    document.body.addEventListener('appViewModelChanged', this.updateAppViewModel);
    document.body.addEventListener('snackbarMessage', this.handleSnackbarMessage);
  }

  componentWillUnmount = () => {
    document.body.removeEventListener('appViewModelChanged', this.updateAppViewModel);
    document.body.removeEventListener('snackbarMessage', this.handleSnackbarMessage);
  }

  handleMobileMenuOpen = event => {
    this.setState({ mobileMoreAnchorEl: event.currentTarget });
  };

  handleMobileMenuClose = () => {
    this.setState({ mobileMoreAnchorEl: null });
  };

  componentDidCatch(error, errorInfo) {
    Sentry.configureScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key]);
      });
    });
    Sentry.captureException(error);
  }

  handleSnackbarMessage = (event) => {
    if(event.detail.response) {
      this.setState({
        snackbarMessageOpen: true,
        snackbarMessageResponse: event.detail.response,
        snackbarMessageType: event.detail.type,

      });
    } else {
      this.setState({
        snackbarMessageOpen: false,
        snackbarMessageResponse: null,
        snackbarMessageType: null,
      });
    }
    
  };

  render() {
    const { classes } = this.props;

    const { mobileMoreAnchorEl } = this.state;
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

    const renderMobileMenu = () => (
      <Menu
        anchorEl={mobileMoreAnchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={isMobileMenuOpen}
        onClose={this.handleMobileMenuClose}
      >
        <MenuItem onClick={this.handleFavorite}>
          <IconButton color="inherit">
            {this.state.edt.favorite ? <StarIcon/> : <StarBorderIcon/>}
          </IconButton>
          <p>{this.state.edt.favorite ? 'Retirer des favoris' : 'Ajouter aux favoris'}</p>
        </MenuItem>
        <MenuItem onClick={this.handleShare}>
          <IconButton color="inherit">
            <ShareIcon />
          </IconButton>
          <p>Partager</p>
        </MenuItem>
        <MenuItem onClick={this.handleSettings}>
          <IconButton color="inherit">
            <SettingsIcon />
          </IconButton>
          <p>Configuration</p>
        </MenuItem>
      </Menu>
    );

    return (
      <BrowserRouter>
        <div className={classes.app}>
          <CssBaseline />
          <AppBar position="static">
            <Toolbar variant="dense">
              <IconButton className={classes.menuButton} color="inherit" aria-label="Menu" onClick={this.toggleDrawer.bind(this)}>
                <MenuIcon />
              </IconButton>
              <Typography variant="h6" color="inherit" className={classes.flex}>
                {this.state.isLoading ? 'Chargement...' : this.state.appBarTitle}
              </Typography>
              {
                (this.state.edt && !this.state.isLoading) && (
                  <React.Fragment>
                    <div className={classes.sectionDesktop}>
                      <IconButton color="inherit" onClick={this.handleFavorite} title={this.state.edt.favorite ? 'Retirer des favoris' : 'Ajouter aux favoris'}>
                        {this.state.edt.favorite ? <StarIcon/> : <StarBorderIcon/>}
                      </IconButton>
                      <IconButton color="inherit" onClick={this.handleShare} title="Partager">
                        <ShareIcon />
                      </IconButton>
                      <IconButton color="inherit" onClick={this.handleSettings} title="Configuration">
                        <SettingsIcon />
                      </IconButton>
                    </div>
                    <div className={classes.sectionMobile}>
                      <IconButton aria-haspopup="true" onClick={this.handleMobileMenuOpen} color="inherit">
                        <MoreIcon />
                      </IconButton>
                    </div>
                  </React.Fragment>
                )
              }

            </Toolbar>
            <Drawer open={this.state.drawerOpened} onClose={this.toggleDrawer.bind(this)}>
              <div
                tabIndex={0}
                role="button"
                onClick={this.toggleDrawer.bind(this)}
                onKeyDown={this.toggleDrawer.bind(this)}
                className={classes.drawerMenuContainer}
              >
                <LoadableMenuDrawer />
              </div>
            </Drawer>
          </AppBar>
          {(this.state.edt && !this.state.isLoading) && renderMobileMenu()}
          <SnackbarMessage open={this.state.snackbarMessageOpen} response={this.state.snackbarMessageResponse} type={this.state.snackbarMessageType}/>
          <Switch>
            <Route exact path="/" component={LoadableAccueil} />
            <Redirect from="/add" to="/edt/add"/>
            <Route exact path="/edt/add" component={LoadableEdtAdd} />
            <Redirect from="/site/faq" to="/faq"/>
            <Route exact path="/faq" component={LoadableFaq} />
            <Redirect from="/site/mentions" to="/mentions"/>
            <Route exact path="/mentions" component={LoadableMentions} />
            <Redirect from="/site/contact" to="/contact"/>
            <Route exact path="/contact" component={LoadableContact} />
            <Redirect from="/site/cookies" to="/cookies"/>
            <Route exact path="/cookies" component={LoadableCookies} />
            <Route exact path="/help" component={LoadableHelp} />
            <Route path="/edt/:edtid" component={LoadableEdt} />
            <Route path="/welcome" component={LoadableWelcomeSlider} />
            <Route path="/redirect" component={LoadableHomeRedirect} />
            <Route component={LoadableNoMatch} />
          </Switch>
        </div>
      </BrowserRouter>
    );
  }
}

export default withStyles(styles)(App);



// WEBPACK FOOTER //
// ./src/App.js